const charitableGiving = {
  title: 'Shop at italist | Our giving model',
  description: 'As a company, we value innovation and believe in supporting the next generation of creative thinkers',
};

export default charitableGiving;
